import React from 'react';
import PropTypes from 'prop-types';
import {
	Container, UserForm, EditUser,
	DashboardProfile, DashboardSummary,
	ContainerLoader, Tasks, SidebarContainer,
	DashboardOverview, DashboardTasks, PipelineSummary,
	RecentlyAddedMaps, ConfirmationPrompt
} from '../';
import {
	fetchPriceSum, fetchOpenLeads, fetchOpenLeadsValue
} from 'api';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import moment from 'moment';
import YouTubePlaylist from 'react-youtube-playlist';
import 'react-youtube-playlist/dist/styles.scss';
import * as Permissions from 'permissions';
import * as Actions from 'actions';


class Dashboard extends React.Component {
    constructor(props) {
      super(props);

      this.state = {
        view_client_details : false,
        completed_sales: 0,
        open_leads: 0,
        open_leads_value: 0,
				show_videos : localStorage && localStorage.getItem('show_videos') == 'false' ? false : true,
				show_subscription_success_prompt: false
      }

			this.toggleShowVideos = this.toggleShowVideos.bind(this);
    }
    refreshPrice() {
      //TODO: Implememnt a refresh button.
    }
    refreshOpenLeads() {
      //TODO: Implement a refresh button.
    }
    refreshLeadsValue() {
      //TODO: Implement a refresh button.
    }

		toggleShowVideos() {
			localStorage.setItem('show_videos', this.state.show_videos ? 'false' : 'true');
			this.setState({show_videos : !this.state.show_videos});
		}

	  componentWillMount() {
	  	this.props.initDashboard();

      fetchPriceSum().then((price) =>this.setState({completed_sales : price.total})).catch(this.props.notify);
      fetchOpenLeads().then((leads) => this.setState({open_leads: leads.total})).catch(this.props.notify);
      fetchOpenLeadsValue().then((value) => this.setState({open_leads_value : value.total})).catch(this.props.notify);

			if((this.props.location.state || {}).show_subscription_success_prompt) {
				this.setState({ show_subscription_success_prompt: true });
			}
	  }

	  componentDidMount() {
	  	// dashboardIntro()
	  }

    componentWillUnmount() {
      this.props.updateTmpUser(null);
    }

    render() {
    	if(this.props.ui.initializing)
				return <ContainerLoader />
      const { open_leads, open_leads_value, completed_sales} = this.state;
    	const menuItems = [];

      return (
      	<div className='dashboard-container'>
	      	<SidebarContainer
	      		is_user={true}
	      		title={`Dashboard`}
	      		menuItems={menuItems}
	      		hide_sidebar_header
	      		>
						<div className="row">
							<div className="mt-lg alert alert-success">
								<h3>Good News!</h3>
								<p>The HailTrace team is excited to announce that we have a new version of the website launching on <b>Feburary 15th</b>!</p>
								<p>We will keep this version available until <b><em>March 1st</em></b>, but you can start getting used to the new system now.</p>
								<br />
								<a href="https://next.hailtrace.com" className="btn btn-info">Launch Beta Website</a>
								<br /><br />
								<a href="https://testflight.apple.com/join/BUc9kWdv" target="_blank" className="btn btn-success">Join our iOS Beta Program</a> or <a href="https://play.google.com/store/apps/details?id=com.hailtrace" className="btn btn-success">Join our Android Beta Program</a>
							</div>
						</div>
						<div className='row'>
							{this.state.show_videos ? (
								<div className='col-md-4 col-md-offset-4 col-xs-4'>
									<h3 className='text-dark' style={{margin : '0 0 5px 0'}}>
										<span><i className='fa fa-video-camera' /></span>
										{' '}"How To"s
									</h3>
								</div>
							) : null}
							<div className='pull-right toggle-show-videos-container'>
								<i
									className={`fa fa-${ this.state.show_videos ? 'times' : 'info-circle'} video-toggle-button`}
									onClick={this.toggleShowVideos}
								/>
							</div>
						</div>
      			<div className='row'>
							{this.state.show_videos ? (
								<div className={`pull-right youtube-playlist-container ${!this.props.hasPermission(Permissions.VIEW_CLIENTS) ? 'full' : ''}`}>
									<YouTubePlaylist
										api_key='AIzaSyCWuH5SGDikY4OPSrbJxqTi4Y2uTgQUggw'
										playlist_id='PL64BwQcJEEVImdziHEAlXzb5Zhzs1KNKT'
										width='100%'
										height='380'
										show_thumbnails
									/>
								</div>
							) : null}
							{this.props.hasPermission(Permissions.VIEW_CLIENTS) ? (
								<div className={`${this.state.show_videos ? 'col-md-4 col-xs-12' : 'col-md-12'}`}>
			        		<DashboardOverview
			        			completed_sales={completed_sales}
			        			open_leads={open_leads}
				        		open_leads_value={open_leads_value}
										show_videos={this.state.show_videos}
			        		/>
								</div>
							) : null}
						</div>
						<div className='row'>
							<div className='col-md-12 col-xs-12'>
								<PipelineSummary />
							</div>
						</div>
	        	<div className='row'>
		        	<div className='col-xs-12 col-md-12 col-lg-12'>
			          {this.props.children}
			        </div>
		        </div>
		      </SidebarContainer>
					<ConfirmationPrompt
						show_condition={this.state.show_subscription_success_prompt}
						handleConfirmPrompt={() => this.setState({ show_subscription_success_prompt: false })}
						handleCancelPrompt={() => this.setState({ show_subscription_success_prompt: false })}
						hide_cancel_button={true}
						title='Success!'
						body='Subscription saved successfully'
						type='success'
					/>
	      </div>
	     );
    }
}

const mapStateToProps = ({ ui }) => ({ ui })

export default connect(mapStateToProps, Actions)(Dashboard);



// WEBPACK FOOTER //
// ./src/browser/components/dashboard/dashboard.js